export default {
    first: 'es',
    es: {
        name_language: 'Español',
        locale: 'es_AR',
        si: 'Sí',
        no: 'No',
        user: 'Usuario',
        password: 'Clave',
        notAccount: 'No tenés cuenta? ',
        registerHere: 'Registrate aquí.',
        login: 'Ingresar',
        forgottenPassword: 'Olvidé mi contraseña',
        loginError: 'Email o password incorrecto',
        userInactive: 'Su usuario no se encuentra activo. Si esto es un error por favor comuníquese con la administración del sistema.',
        conectionError: 'Chequee su conexión a internet y vuelva a intentarlo.',
        generalError: 'Ocurrió un error inesperado. Por favor vuelva intentarlo luego',
        // Register:
        newAccount: 'Crear una cuenta',
        name: 'Nombre',
        sureName: 'Apellido',
        mail: 'Email',
        birthDay: 'Fecha de nacimiento',
        registerPassword: 'Contraseña',
        repeatPassword: 'Ingrese nuevamente su contraseña',
        showPassword: 'Mostrar contraseña',
        hidePassword: 'Ocultar contraseña',
        termsAndConditions: 'He leído y acepto los términos y condiciones.',
        register: 'Registrarme',
        registerSuccess: 'Registro exitoso!',
        registerMessage: 'Te hemos enviado un código de verificación a tu e-mail para que puedas activar tu cuenta y comenzar a compartir viajes.',
        forgetMail: 'Olvidó ingresar su email.',
        invalidMail: 'Ingrese un email válido.',
        forgetPassword: 'Olvidó ingresar su contraseña.',
        minCharsPassword: 'Las contraseña debe tener al menos 8 caracteres.',
        forgetPasswordConfirmation: 'Olvidó confirmar su contraseña.',
        differentPasswords: 'Las contraseñas no coinciden.',
        registerBeneficioPregunta: '¿Aplica descuento por residente o jubilado/a?',
        registerBeneficioSeleccionar: 'Seleccioná una opción',
        registerBeneficioObligatorio: 'Indicá si aplica descuento por residente, jubilado/a o ninguno.',
        sinDescuentoBeneficio: 'No, ninguno',
        forgetName: 'Olvidó ingresar su nombre.',
        forgetSureName: 'Olvidó ingresar su apellido.',
        forgetBirthDay: 'Olvidó ingresar su fecha de nacimiento.',
        notLegalAge: 'Lo sentimos, debes ser mayor de edad para usar el servicio. Para más información te recomendamos leer los términos y condiciones.',
        inUseMail: 'La cuenta de email ingresada se encuentra en uso.',
        zonas: 'Zonas',
        zonaMensajeSeleccion: 'Seleccione una zona ..',
        notSelectedZone: 'Debes seleccionar una zona.',
        aceptaPagoElectronico: '¿Acepta pagos electrónicos? (Ej: tarjetas de crédito, débito, etc)',
        pagoElectronicoAceptado: 'El chofer acepta pago electrónico.',
        nombreNoCoincideTarjeta: 'La tarjeta tiene otro nombre',

        aceptaMascotas: '¿Acepta mascotas?',
        aceptaViajeAfuera: '¿Acepta viaje fuera de zona?',

        // Upgrade Chofer:
        fotoPerfil: 'Foto de perfil',
        upgradeTitle: 'Registrarse como chofer',
        datoVehiculo: 'Datos del vehículo:',
        dni: 'DNI',
        celular: 'Celular',
        patente: 'Patente',
        chapa: 'Chapa (RA)',
        licenciaConductor: 'Licencia de conducir',
        cuentaBancaria: 'Cuenta bancaria para depósitos',
        descripcionVehiculo: 'Descripción del vehículo',
        modelo: 'Modelo (año)',
        color: 'Color',
        companiaAseguradora: 'Compañía aseguradora',
        tipoVehiculo: 'Tipo de vehículo',
        tipoServicio: 'Servicios que realiza',
        forgetDni: 'Olvidó ingresar su DNI.',
        forgetCelular: 'Olvidó ingresar su número de celular.',
        forgetPatente: 'Olvidó ingresar su patente.',
        forgetChapa: 'Olvidó ingresar su número de chapa.',
        forgetLicencia: 'Olvidó ingresar su número de licencia.',
        forgetCuentaBancaria: 'Olvidó ingresar su número de cuenta bancaria.',
        forgetDescripcionVehiculo: 'Olvidó ingresar la descripción de su vehículo.',
        forgetModelo: 'Olvidó ingresar el modelo de su vehículo.',
        forgetColor: 'Olvidó ingresar el color de su vehículo.',
        forgetCompaniaAseguradora: 'Olvidó ingresar su compañía de seguros.',
        forgetTipoVehiculo: 'Olvidó ingresar el tipo de vehículo.',
        forgetTipoServicio: 'Olvidó ingresar los servicios que realiza.',
        minDocumentacion: 'Debe adjuntar la documentación necesaria.',
        imagenSubidaFallida: 'Hubo un problema durante la carga de la imagen.',
        imagenSubidaExitosa: 'Imagen cargada exitosamente.',
        confirmacionDatos: 'Confirmación de los datos',
        documentacionNecesaria: 'Por favor adjunta la imagen de tu documentación para poder verificar tu usuario como chofer.',
        uploadFiles: 'Elegir archivos',
        forgetProfilePic: 'Olvidó elegir una foto de perfil.',
        forgetDocumentacion: 'Olvidó selecionar la imagen del tarjetón.',
        upgradeSuccess: 'Hemos recibido su solicitud. En breve recibirá un correo con la confirmación de la misma.',
        registerAsDriverPostLogin: 'Podés registrarte como chofer desde el menú superior, seleccionando «{menuItem}».',
        bigImage: 'La imagen no debe superar los 4MB',
        bigImages: 'Las imagenes no deben superar los 4MB',
        datosVehiculo: 'Datos del vehículo',
        preguntaTipoVehiculo: '¿Qué vehículo manejas?',

        // Recovery Password:
        recoveryPassword: 'Recuperar contraseña',
        emailSent: 'Email enviado',
        recoveryIndications: 'Se ha enviado un email a su casilla de correo con su nueva contraseña.',
        userDoesntExist: 'El e-mail ingresado no pertenece a ningún usuario.',

        // Passenger Request Trip:
        pedirTaxi: 'Pedir taxi',
        precioEstimado: 'Precio aprox.',
        precioFinal: 'Costo del traslado',
        descuentoResidenteJubiladoAplicado: 'Descuento residente/jubilado aplicado ({pct}%)',
        descuentoBeneficioPendienteEstimacion: 'Esta tarifa tendrá un descuento de {pct}% al verificar su condición por parte del conductor',
        descuentoAtajoZonaAplicado: 'Descuento por traslado ({pct}%)',
        descuentoTarifaAplicado: 'Descuento aplicado ({pct}%)',
        descuentoTarifaAplicadoFallback: 'Descuento aplicado',
        beneficioResidenteJubiladoTitulo: 'Descuento residente / jubilado',
        beneficioResidenteJubiladoAyuda: 'Si sos residente o jubilado podés solicitar un descuento en el viaje. La validación se realiza con el chofer al subir por primera vez.',
        tipoBeneficio: 'Tipo de beneficio',
        residente: 'Residente',
        jubilado: 'Jubilado',
        estadoBeneficio: 'Estado',
        beneficioAprobado: 'Aprobado',
        beneficioPendiente: 'Pendiente de validación',
        beneficioRechazado: 'Rechazado',
        seleccioneTipoBeneficio: 'Seleccione...',
        enviarDocumentoBeneficio: 'Solicitar beneficio',
        beneficioSolicitudEnviada: 'Solicitud enviada. El chofer validará su identidad al iniciar su primer viaje.',
        beneficioPendienteValidacionChofer: 'Al subir al viaje, el chofer le solicitará DNI o carnet de jubilado para validar este beneficio.',
        beneficioRechazadoNoResolicitud: 'El beneficio fue rechazado y no podrá volver a solicitarse.',
        errorEnviandoDocumentoBeneficio: 'Error al solicitar el beneficio. Intente nuevamente.',
        emptyDestinationError: 'Debe ingresar un destino para pedir un taxi',
        serviceIncompatible: 'El tipo de servicio seleccionado es incompatible.',
        confirmacionDireccion: '¿Estás seguro que deseas pedir un servicio a la dirección ',
        efectivo: 'Efectivo',
        pagoElectronico: 'Pago electrónico',
        placeholderText: 'Ingrese la dirección de destino.',
        outOfRegion: 'El viaje solicitiado se encuentra fuera del área de cobertura.',
        errorWithPayment: 'Ocurrió un error validando el pago, vuelva a intentarlo.',
        mustChoosePayment: 'Debes seleccionar un método de pago.',
        problemaInesperado: 'Ocurrió un error inesperado. Pruebe revisando su conexión a internet.',
        seleccioneEmpresa: 'Selecione una empresa de taxi.',
        cualquierEmpresa: 'Todas las empresas de taxi',
        deIdaVuelta: 'De ida y vuelta',
        origen: 'Origen',
        destino: 'Destino',
        placeholderOrigen: 'Ingrese la dirección de origen',
        cotizacionTitulo: 'Cotizar viaje',
        cotizacionIntro: 'Podés ver el precio aproximado sin iniciar sesión. Elegí origen y destino.',
        cotizacionLogin: 'Iniciar sesión para pedir un viaje',
        cotizacionDesdeLogin: 'Cotizar viaje sin iniciar sesión',
        cotizacionCalcularTarifa: 'Calcular tarifa',
        cotizacionAccionGps: 'GPS',
        cotizacionAccionMapa: 'Mapa',
        cotizacionAccionInvertir: 'Invertir',
        cotizacionGpsOrigenAria: 'Usar mi ubicación como origen',
        cotizacionGpsDestinoAria: 'Usar mi ubicación como destino',
        cotizacionMapaOrigenAria: 'Elegir origen en el mapa',
        cotizacionMapaDestinoAria: 'Elegir destino en el mapa',
        cotizacionInvertirAria: 'Invertir origen y destino',
        cotizacionMapaTituloOrigen: 'Elegir origen en el mapa',
        cotizacionMapaTituloDestino: 'Elegir destino en el mapa',
        cotizacionMapaAyuda: 'Mové el mapa para centrar el punto. Tras moverlo, esperá unos segundos y tocá confirmar.',
        cotizacionConfirmarUbicacion: 'Confirmar ubicación',
        cotizacionMiUbicacion: 'Usar mi ubicación',
        cotizacionSinPrecio: 'No se pudo calcular un precio para esta combinación.',
        cotizacionTarifaResidente: 'Tarifa residente',
        cotizacionTarifaJubilado: 'Tarifa jubilado/a',
        cotizacionTarifaNoResidente: 'Tarifa no residente',
        cotizacionBeneficioLabel: 'Descuento residente / jubilado',
        cotizacionPedirEnApp: 'Pedir este viaje en la app',
        cotizacionPedirViaje: 'Pedir este viaje',
        tipoServicioPasajero: 'Tipo de servicio',
        errorCalculandoPrecio: 'No se pudo calcular el precio del viaje. Intente nuevamente.',
        estimacionDistancia: 'Distancia estimada del recorrido',
        calleSinNombre: 'Calle sin nombre',

        esUnaReserva: 'Programar para otro horario o día',
        reservaPedidoAhoraAyuda: 'Para pedir un viaje ahora, dejá esta casilla sin marcar.',
        fechaReserva: 'Fecha del viaje',
        horaReserva: 'Hora del viaje',
        reservaFechaHoraRequeridas: 'Indique la fecha y hora para la reserva.',
        reservaFechaHoraFuturas: 'La fecha y hora de la reserva deben ser futuras.',
        reservaCompletando: 'Completando su reserva...',
        reservaListo: 'Reserva creada. Buscando chofer disponible...',
        reservaBuscandoChofer: 'Buscando chofer para tu reserva',
        reservaBuscandoChoferDetalle: 'Te avisaremos cuando un chofer acepte tu solicitud.',
        reservaAceptadaTitulo: '¡Reserva aceptada!',
        reservaPagoHomeHint: 'Tenés 5 minutos para pagar desde aquí. Después podés pagar en Mis reservas.',
        reservaPagoCountdown: 'Tiempo para pagar: {time}',
        reservaPagoVencidoCountdown: 'Plazo de pago vencido',
        reservaPagoVencidoTitulo: 'Plazo de pago vencido en inicio',
        reservaPagoVencidoMensaje: 'El pago debe realizarse desde Mis reservas.',
        reservaNoAceptadaMensaje: 'Tu reserva no fue aceptada por ningún chofer. Deberás realizar una nueva solicitud.',
        reservaPagadaChofer: 'El pasajero pagó la reserva.',
        pagarReserva: 'Pagar reserva',
        cancelarReserva: 'Cancelar reserva',
        confirmarCancelacionReserva: '¿Confirmás que querés cancelar esta reserva?',
        reservaCanceladaExito: 'Reserva cancelada.',
        reservaSinDatos: 'No se encontraron los datos de la reserva.',
        reservaConfirmada: 'Su reserva fue creada y quedó pendiente de asignación de chofer.',
        viajeReservado: 'Viaje reservado',
        misReservas: 'Mis reservas',
        reservasAceptadas: 'Reservas aceptadas',
        misReservasVacio: 'No tiene reservas.',
        sinReservasAceptadas: 'No tiene reservas aceptadas pendientes.',
        estadoPendiente: 'Pendiente',
        estadoAceptado: 'Aceptado',
        estadoAbordado: 'En curso',
        estadoFinalizado: 'Finalizado',
        moduloNoDisponible: 'Módulo no disponible.',

        mascotas: 'Mascotas',
        lleva: 'Lleva:',
        viajo_con: 'Viajo con ....',
        maletas: 'Maletas',
        silla_ruedas: 'Silla de ruedas',
        viaje_afuera: 'Viaje fuera de zona!!!',
        viajeAfuera: 'Viaje afuera',

        // Passenger Request Waiting:
        buscando: 'Buscando',
        cancelar: 'Cancelar',
        cancelarConCargo: 'Cancelar con cargo',
        mensajeEspera: 'Todos los móviles en este momento están ocupados, por favor vuelva a intentarlo en unos minutos.',

        activarGeolocalizacion: 'Activar geolocalización',
        destinoOpcional: 'Seleccione un destino (opcional)',
        destinoPrecioAyuda: 'Si ud. Ingresa la dirección de destino (dirección exacta) le daremos un tarifa aproximada del traslado.',
        destinoPrecioLeyenda: 'La tarifa indicada es aproximada Y no contempla paradas o desvíos de recorridos.',
        placeholderInputOrigen: 'Ingrese la dirección',

        // Passenger Wainting for Trip
        chofer: 'Chofer',
        tiempoEspera: 'Tiempo de espera',
        tel: 'Tel.',
        // Passenger Taxi arrived
        subir: 'Subir',
        calificar: 'Calificar',
        comoCalificaria: '¿Con cuántas estrellas calificarías el viaje?',
        comoCalificariaPasajero: 'Calificar pasajero',
        debeCalificar: 'Debe calificarse el viaje para poder finalizarse.',
        debeCalificarPasajero: 'Debe calificar al pasajero para finalizar el viaje.',
        finalizar: 'Finalizar',

        // Driver
        pasajerx: 'Pasajera/o',
        metodoPago: 'Método de pago',
        usuarioNuevo: '(nueva/o)',
        enDestino: 'En destino',
        comenzarViaje: 'Comenzar viaje',
        finalizarViaje: 'Finalizar viaje',
        registrarViaje: 'Registrar viaje',
        ingreseImporte: 'Ingrese el importe',
        maximo: 'máximo',
        precio: 'Precio',
        ingreseRecargo: 'Ingrese el recargo',
        recorrido: 'Recorrido',
        aceptar: 'Aceptar',
        rechazar: 'Rechazar',
        movilLibre: 'Móvil libre',
        noDisponible: 'No disponible',
        advertenciaCambiarANoDisponible: '¿Estás segura/o que deseas cambiarte al estado NO DISPONIBLE? Dejarás de recibir notificaciones de solicitudes de viajes.',
        viajesConcretados: '% de viajes concretados',
        errorWithAcceptTrip: 'Ocurrió un error aceptando el viaje.',
        waitUntilTripConfirmation: 'Espere hasta recibir confirmación.',
        beneficioValidacionChoferMensaje: 'Este pasajero solicitó beneficio de tipo {tipo}. Antes de iniciar el viaje, solicitale DNI o carnet correspondiente para validar su identidad.',
        beneficioValidacionChoferConfirmacion: '¿La documentación presentada confirma la condición de {tipo}? Si no, el beneficio quedará rechazado y no volverá a solicitarse.',
        beneficioDescuentoPendienteChofer: 'Este viaje tendrá un descuento de {pct}% al confirmar la condición del pasajero.',
        // Profile
        myProfile: 'Mi perfil',
        profileTitle: 'Editar Perfil',
        actualizarPerfil: 'Actualizar Perfil',
        telefono: 'Teléfono',
        forgetPhone: 'Olvidó ingresar su número.',
        actualizacionExitosa: 'Perfil actualizado con éxito',
        actualizacionFallida: 'Hubo un problema al actualizar su usuario',
        actualizacionImagenFallida: 'Hubo un problema al actualizar su foto de perfil',
        actualizacionImagenExitosa: 'Foto actualizada con éxito',
        logout: 'Cerrar sesión',
        rango: 'Rango de búsqueda: ',
        close: 'Cerrar',
        deleteAccount: 'Borrar cuenta',

        // Promotions
        myCoupons: 'Mis cupones',
        promotionsTitle: 'Promociones',
        activePromotions: 'Promociones activas',
        takenPromotions: 'Promociones reclamadas',
        noTakenPromotions: 'Promociones no reclamadas',
        noPromotions: 'No hay promociones',
        en: 'En',
        promoCode: 'Código Promoción',
        validoHasta: 'Válido hasta',
        noOlvidesCuponPromocion: 'No olvides elegir tu cupón de descuento al finalizar el viaje',
        errorPagoElectronico: 'El cobro electrónico no pudo procesarse.',
        encontraTuCupon: 'Encontrá tu cupón en el menú principal. Validez {hours} horas.',
        errorLimitePromociones: 'Alcanzaste el límite de promociones que podés canjear este mes. Podrás nuevamente acceder a nuestras promociones el mes que viene.',
        seleccionarPromocion: 'Seleccionar promoción',
        quieroEsaPromo: 'Quiero esa promo',
        debeSeleccionarUnaPromo: 'Debes elegir al menos una promo.',
        deseasElegirPromocion: '¿Deseas elegir tu cupón de descuento?',
        promociones: 'Promociones',
        sinPromociones: 'Todavía no has accedido a ninguna de nuestras promociones.',
        usoDelComerciante: 'Solo para uso del comerciante',
        canjear: 'Canjear',
        canjeadoConExito: 'Promoción canjeado con éxito.',
        canjeadoConError: 'Ocurrió un error al canjear la promoción. Por favor vuelva a intentarlo más tarde.',
        secretEquivocado: 'El código ingresado es incorrecto',
        explicacionPromocionnes: 'Deberás mostrar en el Comercio seleccionado el Cupón elegido. En dicho comercio ingresarán un código en tu celular para hacer efectiva la Promo.',
        explicacionBeneficios: 'Mostrá tu beneficio en el comercio y canjealo escaneando su QR o ingresando el código de validación.',
        beneficiosRestantes: 'Te quedan {restantes} de {maximas} beneficios para este viaje',
        beneficiosLimiteAlcanzado: 'Ya elegiste todos los beneficios disponibles para este viaje.',
        sinPromocionesDisponibles: 'No hay promociones disponibles en este momento.',
        tarjetaCreadaExito: 'Beneficio agregado. Válido por {dias} días.',
        finalizarSeleccion: 'Finalizar',
        seleccionar: 'Seleccionar',
        promocionYaElegida: 'Ya elegiste esta promoción para este viaje.',
        viajeNoFinalizadoBeneficio: 'Solo los viajes finalizados generan beneficios.',
        canjearBeneficio: 'Canjear beneficio',
        escanearQr: 'Escanear QR del comercio',
        ingresarCodigo: 'Ingresar código manual',
        codigoComercioPlaceholder: 'Código del comercio',
        qrInvalido: 'El QR escaneado no es válido.',
        qrScanError: 'No se pudo acceder a la cámara para escanear el QR.',
        tarjetaVencida: 'Este beneficio ya venció.',
        tarjetaYaUtilizada: 'Este beneficio ya fue utilizado.',
        estadoUtilizada: 'Utilizada',
        estadoVencida: 'Vencida',

        // Historial
        historialTitle: 'Historial de viajes',
        totalViajes: 'Total de viajes',
        desde: 'Desde',
        hasta: 'Hasta',
        noHayViajes: 'No hay viajes',

        // Terms
        termsTitle: 'Términos y condiciones',

        // Cancel Card
        cancelReason: 'Razón de cancelación',
        reasonShortMessage: 'Debes escribir la razón por la que cancelas el viaje.',
        reasonNoMessage: 'Debes seleccionar la razón por la que cancelas el viaje.',
        confirmarCancelacion: '¿Estás seguro que desea cancelar el viaje?',
        confirmarCancelacionConCargo: '¿Estás seguro que desea cancelar el viaje (DEBERÁS PAGAR EL MONTO MÍNIMO)?',

        // Trip
        viajeDoesntExist: 'El viaje ya no existe.',
        viajeCaneladoPorChofer: 'El chofer canceló el viaje.',
        viajeCaneladoPorPasajero: 'El viaje fue cancelado por el pasajero.',
        viajeCaneladoPreviamentePorPasajero: 'El viaje fue cancelado previamente por el pasajero.',
        viajeOfrecidoCancelado: 'El viaje fue cancelado por el pasajero.',
        viajeOfrecidoTomadoPorOtroChofer: 'El viaje fue tomado por otro chofer.',
        reason: ' Razón: ',

        // Historial
        compartirApp: 'Compartir aplicación',
        compartirMensaje: 'Aplicación para solicitar viajes en taxis.',

        // Atajos
        myUbication: 'Mi ubicación actual',
        language: 'Idioma',

        // Menu desplegable
        perfil: 'Perfil',
        history: 'Historial',
        promotions: 'Promociones',
        compartir: 'Compartir',
        toc: 'Términos y condiciones',
        registrameComoChofer: 'Registrarme como chofer',
        contacto: 'Contacto',

        metodosPago: 'Métodos de pago',
        explicacionMetodoPagoDefault: 'Seleccione el modo en el cuál desea pagar sus viajes por defecto.',
        configurar: 'Configurar',
        agregarMedioPago: 'Guardar medio de pago',
        noHayMetodos: 'No agregó métodos de pago.',
        terminadaEn: 'terminada en',
        expiraEl: 'expira el',

        telefonoCelular: 'Teléfono celular',
        ingrese15: 'Ingrese el número sin 0 y sin 15.',
        cambiarContrasenia: 'Cambiar contraseña',
        numerosSeguridad: 'Números de seguridad',

        agregar: 'Agregar',
        quitar: 'Quitar',
        numerosSeguridadAyuda: 'Ingrese hasta 2 números de seguridad que serán notificados por SMS en caso de que usted esté en peligro.',
        calificarViaje: 'Calificar el viaje',

        // Cuenta corriente
        currentAccount: 'Cuenta corriente',
        noMovements: 'No se realizaron movimientos.',
        totalMovements: 'Movimientos totales',
        noVolverAMostrar: 'No volver a mostrar este mensaje',
        // App update
        appNewVersion: 'Hay una actualización disponible para la aplicación. Por favor mantengase actualizado para obtener el mejor servicio.',

        // servicios
        transportePersonas: 'Transporte de personas',
        transporteMascotas: 'Transporte de mascotas',
        mensajeria: 'Mensajería',
        precioSufijo: '',
        precioPrefijo: '$',
        precioActual: 'Precio actual',
        iconMoney: 'money',

        // mensajes
        audioEnviadoExito: 'Audio enviado con exito',
        procesandoAudio: 'Procesando audio',
        escribaMensaje: 'Escriba un mensaje',
        chatTitle: 'Chat',

        // otros
        saludo: 'Hola, {name}. ¿A dónde vas?'
    },
    en: {
        name_language: 'English',
        locale: 'en_US',
        si: 'Yes',
        no: 'No',
        user: 'User',
        password: 'Password',
        notAccount: 'Don\'t have an account?',
        registerHere: 'Sign up',
        login: 'Login',
        forgottenPassword: 'Forgot password',
        loginError: 'Email or password are incorrect.',
        userInactive: 'Your user is not active. If this is an error please contact the system administration.',
        conectionError: 'Check your internet connection and try again.',
        generalError: 'An error has ocurred, please try again later.',
        // Register:
        newAccount: 'Create account',
        name: 'Firstname',
        sureName: 'Lastname',
        mail: 'Email',
        birthDay: 'Birthdate',
        registerPassword: 'Password',
        repeatPassword: 'Repeat password',
        showPassword: 'Show password',
        hidePassword: 'Hide password',
        termsAndConditions: 'I have read and accept the terms and conditions',
        register: 'Sign up',
        registerSuccess: 'Succesfully create account',
        registerMessage: 'We have sent a verification code to your e-mail so you can activate your account and start sharing trips.',
        forgetMail: 'Email is required.',
        invalidMail: 'Invalidad email.',
        forgetPassword: 'Password is required.',
        minCharsPassword: 'The password must have 8 characters.',
        forgetPasswordConfirmation: 'Confirm password is required.',
        differentPasswords: 'The password doesn\'t match.',
        registerBeneficioPregunta: 'Do you qualify for a resident or retiree discount?',
        registerBeneficioSeleccionar: 'Select an option',
        registerBeneficioObligatorio: 'Please indicate resident discount, retiree discount, or none.',
        sinDescuentoBeneficio: 'No, none',
        forgetName: 'Firstname is required.',
        forgetSureName: 'Birthdate is required',
        notLegalAge: 'Sorry, you must be of legal age to use the service. For more information we recommend you read the terms and conditions.',
        inUseMail: 'Email is already register.',
        zonas: 'Areas',
        zonaMensajeSeleccion: 'Pickup an area ..',
        notSelectedZone: 'Area is required',
        aceptaPagoElectronico: '¿Do you accept electronic payments?',
        pagoElectronicoAceptado: 'The driver accept electronic payments.',
        nombreNoCoincideTarjeta: 'The credit card has other holder name',

        // Upgrade Chofer:
        fotoPerfil: 'Profile image',
        upgradeTitle: 'Register as driver',
        datoVehiculo: 'Vehicle data:',
        dni: 'Driver license Id',
        celular: 'Mobile phone',
        patente: 'License plate',
        chapa: 'Vehicle ID',
        licenciaConductor: 'Driver license',
        cuentaBancaria: 'Bank Account for deposits',
        descripcionVehiculo: 'Vehicle description',
        modelo: 'Year model',
        color: 'Colour',
        companiaAseguradora: 'Asurance company',
        tipoVehiculo: 'Vehicle type',
        tipoServicio: 'Services performed',
        forgetDni: 'Driver license is required.',
        forgetCelular: 'Mobile phone is required.',
        forgetPatente: 'License plate is required.',
        forgetChapa: 'Vehicle Id is required.',
        forgetLicencia: 'Driver license is required.',
        forgetCuentaBancaria: 'Bank account is required.',
        forgetDescripcionVehiculo: 'Vehicle description is required.',
        forgetModelo: 'Year model is required.',
        forgetColor: 'Colour is required.',
        forgetCompaniaAseguradora: 'Asurance company is required.',
        forgetTipoVehiculo: 'Vehicle type is required.',
        forgetTipoServicio: 'Services performed is required.',
        imagenSubidaFallida: 'An error ocurred when uploading the image, please try again.',
        imagenSubidaExitosa: 'Image succesfully loaded.',
        confirmacionDatos: 'Information confirmation',
        documentacionNecesaria: 'Please attach driver documentation images in order to us verify you as a driver.',
        uploadFiles: 'Choose file',
        forgetProfilePic: 'Profile image is required.',
        forgetDocumentacion: 'Documentation images are required.',
        upgradeSuccess: 'We have received your request You will receive an email shortly with the confirmation of the same.',
        registerAsDriverPostLogin: 'You can register as a driver from the top menu by selecting «{menuItem}».',
        bigImage: 'The image must not exceed 4MB',
        bigImages: 'The images must not exceed 4MB',
        datosVehiculo: 'Vehicle data',
        preguntaTipoVehiculo: 'What type vehicle do you drive?',

        // Recovery Password:
        recoveryPassword: 'Recover password',
        emailSent: 'An email was sent',
        recoveryIndications: 'An email has been sent to your mailbox with your new password.',
        userDoesntExist: 'The email does not belong to any user.',

        // Passenger Request Trip:
        pedirTaxi: 'Request vehicle',
        precioEstimado: 'Estimated trip price',
        precioFinal: 'Trip price',
        descuentoResidenteJubiladoAplicado: 'Resident/senior discount applied ({pct}%)',
        descuentoBeneficioPendienteEstimacion: 'This fare will include a {pct}% discount once the driver verifies your eligibility',
        descuentoAtajoZonaAplicado: 'Shortcut discount applied ({pct}%)',
        descuentoTarifaAplicado: 'Discount applied ({pct}%)',
        descuentoTarifaAplicadoFallback: 'Discount applied',
        beneficioResidenteJubiladoTitulo: 'Resident / senior discount',
        beneficioResidenteJubiladoAyuda: 'If you are a resident or retiree, you can request a trip discount. Validation is done by the driver when you board your first trip.',
        tipoBeneficio: 'Benefit type',
        residente: 'Resident',
        jubilado: 'Retiree',
        estadoBeneficio: 'Status',
        beneficioAprobado: 'Approved',
        beneficioPendiente: 'Pending validation',
        beneficioRechazado: 'Rejected',
        seleccioneTipoBeneficio: 'Select...',
        enviarDocumentoBeneficio: 'Request benefit',
        beneficioSolicitudEnviada: 'Request sent. The driver will validate your identity when your first trip starts.',
        beneficioPendienteValidacionChofer: 'When boarding, the driver will ask for your ID or retiree card to validate this benefit.',
        beneficioRechazadoNoResolicitud: 'The benefit was rejected and cannot be requested again.',
        errorEnviandoDocumentoBeneficio: 'Error requesting the benefit. Please try again.',
        emptyDestinationError: 'Destiny is required to request a vehicle',
        serviceIncompatible: 'The selected service type is incompatible.',
        confirmacionDireccion: 'Are you sure you want a vehicle for the address ',
        efectivo: 'Cash',
        pagoElectronico: 'Electronic payment',
        placeholderText: 'Destination is required',
        outOfRegion: 'The requested origin is outside our coverage area.',
        errorWithPayment: 'An error ocurred while validating the payment, please try again.',
        mustChoosePayment: 'You must select a payment method',
        problemaInesperado: 'An unexpected error occurs. Try checking yours internet connection.',
        seleccioneEmpresa: 'Choose a taxi company.',
        cualquierEmpresa: 'All taxi company',
        deIdaVuelta: 'Roundtrip',
        viajeAfuera: 'Out-of-zone trip',
        origen: 'Origin',
        destino: 'Destination',
        placeholderOrigen: 'Enter pickup address',
        cotizacionTitulo: 'Fare estimate',
        cotizacionIntro: 'You can see an approximate fare without signing in. Choose origin and destination.',
        cotizacionLogin: 'Sign in to request a trip',
        cotizacionDesdeLogin: 'Estimate a trip without signing in',
        cotizacionCalcularTarifa: 'Calculate fare',
        cotizacionAccionGps: 'GPS',
        cotizacionAccionMapa: 'Map',
        cotizacionAccionInvertir: 'Swap',
        cotizacionGpsOrigenAria: 'Use my location as origin',
        cotizacionGpsDestinoAria: 'Use my location as destination',
        cotizacionMapaOrigenAria: 'Pick origin on map',
        cotizacionMapaDestinoAria: 'Pick destination on map',
        cotizacionInvertirAria: 'Swap origin and destination',
        cotizacionMapaTituloOrigen: 'Pick origin on map',
        cotizacionMapaTituloDestino: 'Pick destination on map',
        cotizacionMapaAyuda: 'Move the map to center the pin. After moving, wait a few seconds, then confirm.',
        cotizacionConfirmarUbicacion: 'Confirm location',
        cotizacionMiUbicacion: 'Use my location',
        cotizacionSinPrecio: 'Could not calculate a fare for this combination.',
        cotizacionTarifaResidente: 'Resident fare',
        cotizacionTarifaJubilado: 'Retiree fare',
        cotizacionTarifaNoResidente: 'Non-resident fare',
        cotizacionBeneficioLabel: 'Resident / senior discount',
        cotizacionPedirEnApp: 'Request this trip in the app',
        cotizacionPedirViaje: 'Request this trip',
        tipoServicioPasajero: 'Service type',
        errorCalculandoPrecio: 'Could not calculate the trip fare. Please try again.',
        estimacionDistancia: 'Estimated trip distance',
        calleSinNombre: 'Unnamed street',

        esUnaReserva: 'Schedule for another time or day',
        reservaPedidoAhoraAyuda: 'To request a trip now, leave this box unchecked.',
        fechaReserva: 'Trip date',
        horaReserva: 'Trip time',
        reservaFechaHoraRequeridas: 'Please enter the date and time for the reservation.',
        reservaFechaHoraFuturas: 'The reservation date and time must be in the future.',
        reservaCompletando: 'Completing your reservation...',
        reservaListo: 'Reservation created. Looking for an available driver...',
        reservaBuscandoChofer: 'Looking for a driver for your reservation',
        reservaBuscandoChoferDetalle: 'We will notify you when a driver accepts your request.',
        reservaAceptadaTitulo: 'Reservation accepted!',
        reservaPagoHomeHint: 'You have 5 minutes to pay from here. After that, pay from My reservations.',
        reservaPagoCountdown: 'Time to pay: {time}',
        reservaPagoVencidoCountdown: 'Payment window expired',
        reservaPagoVencidoTitulo: 'Payment window expired on home',
        reservaPagoVencidoMensaje: 'Please complete payment from My reservations.',
        reservaNoAceptadaMensaje: 'Your reservation was not accepted by any driver. Please create a new request.',
        reservaPagadaChofer: 'The passenger paid for the reservation.',
        pagarReserva: 'Pay reservation',
        cancelarReserva: 'Cancel reservation',
        confirmarCancelacionReserva: 'Are you sure you want to cancel this reservation?',
        reservaCanceladaExito: 'Reservation cancelled.',
        reservaSinDatos: 'Reservation data not found.',
        reservaConfirmada: 'Your reservation was created and is pending driver assignment.',
        viajeReservado: 'Reserved trip',
        misReservas: 'My reservations',
        reservasAceptadas: 'Accepted reservations',
        misReservasVacio: 'You have no reservations.',
        sinReservasAceptadas: 'No accepted reservations pending.',
        estadoPendiente: 'Pending',
        estadoAceptado: 'Accepted',
        estadoAbordado: 'In progress',
        estadoFinalizado: 'Completed',
        moduloNoDisponible: 'Module not available.',

        mascotas: 'Pets',
        maletas: 'Luggage',
        silla_ruedas: 'Wheelchair',
        lleva: 'Brings:',

        // Passenger Request Waiting:
        buscando: 'Searching',
        cancelar: 'Cancel',
        cancelarConCargo: 'Cancel with charge',
        mensajeEspera: 'All drivers are currently busy, please try again in a few minutes.',

        activarGeolocalizacion: 'Enable geolocalization',

        destinoOpcional: 'Select a destiny (optionaly)',
        destinoPrecioAyuda: 'If you enter enter the destination address (exact address) we will give you an approximate transfer fee.',
        destinoPrecioLeyenda: 'The indicated fare is approximate and does not include stops or detours of routes.',

        // Passenger Wainting for Trip
        chofer: 'Driver',
        tiempoEspera: 'Wait time',
        tel: 'Phone',
        // Passenger Taxi arrived
        subir: 'Get on',
        calificar: 'Rate',
        comoCalificaria: 'With how many stars would you rate the trip?',
        comoCalificariaPasajero: 'Passenger rating',
        debeCalificar: 'The trip must be qualified to be finalized.',
        debeCalificarPasajero: 'The passenger must be rated to register the trip.',
        finalizar: 'End trip',

        // Driver
        pasajerx: 'Passenger',
        metodoPago: 'Payment method',
        usuarioNuevo: '(new user)',
        enDestino: 'On destiny',
        comenzarViaje: 'Start trip',
        finalizarViaje: 'End trip',
        registrarViaje: 'Register trip',
        ingreseImporte: 'Enter amount',
        maximo: 'max',
        precio: 'Price',
        ingreseRecargo: 'Enter recharge',
        recorrido: 'Route',
        aceptar: 'Accept',
        rechazar: 'Reject',
        movilLibre: 'Available vehicle',
        noDisponible: 'Unavailable',
        advertenciaCambiarANoDisponible: 'Are you sure you want to change to the state NOT AVAILABLE? You will stop receiving notifications of travel requests.',
        viajesConcretados: '% fullfilled trips',
        errorWithAcceptTrip: 'An error ocurred while accepting the trip.',
        waitUntilTripConfirmation: 'Wait until receive the trip confirmation.',
        beneficioValidacionChoferMensaje: 'This passenger requested a {tipo} benefit. Before starting the trip, ask for ID or the corresponding card to validate identity.',
        beneficioValidacionChoferConfirmacion: 'Does the provided documentation confirm the {tipo} condition? If not, the benefit will be rejected and cannot be requested again.',
        beneficioDescuentoPendienteChofer: 'This trip will have a {pct}% discount once the passenger condition is confirmed.',

        // Profile
        myProfile: 'My profile',
        profileTitle: 'Edit profile',
        actualizarPerfil: 'Update profile',
        telefono: 'Phone number',
        forgetPhone: 'Phone number is required',
        actualizacionExitosa: 'Profile succesfully updated.',
        actualizacionFallida: 'An error ocurred when updatind the profile. Please try again.',
        actualizacionImagenFallida: 'An error ocurred when updatind the profile image. Please try again.',
        actualizacionImagenExitosa: 'Profile image succesfully updated',
        logout: 'Logout',
        rango: 'Search range: ',
        close: 'Close',
        deleteAccount: 'Delete account',

        // Promotions
        myCoupons: 'My coupons',
        promotionsTitle: 'Promotions',
        activePromotions: 'Active promotions',
        takenPromotions: 'Taken promotions',
        noTakenPromotions: 'No taken promotions',
        noPromotions: 'No promotions',
        en: 'In',
        promoCode: 'Promo Code',
        validoHasta: 'Valid until',
        noOlvidesCuponPromocion: 'Do not forget to choose your discount coupon at the end of the trip.',
        errorPagoElectronico: 'The electronic payment could not be processed.',
        encontraTuCupon: 'Find your coupon in the main menu. Validity {hours} hours.',
        errorLimitePromociones: 'You reached the limit of promotions that you can redeem this month. You will be able to access our promotions again next month.',
        seleccionarPromocion: 'Select promotion',
        quieroEsaPromo: 'I want this promotion',
        debeSeleccionarUnaPromo: 'You must select a promotion.',
        deseasElegirPromocion: 'Do you want to choose your promotion coupon?',
        promociones: 'Promotions',
        sinPromociones: 'You have not yet accessed any of our promotions.',
        usoDelComerciante: 'Use only by the merchant',
        canjear: 'Exchange',
        canjeadoConExito: 'Promotion exchanged succesfully',
        canjeadoConError: 'An error has ocurred',
        secretEquivocado: 'The code is invalid',
        explicacionPromocionnes: 'You must show in the selected market the coupon chosen. In this market the merchant will enter a code, in your cellphone, to make the promotion effective.',
        explicacionBeneficios: 'Show your benefit at the merchant and redeem it by scanning their QR or entering the validation code.',
        beneficiosRestantes: 'You have {restantes} of {maximas} benefits left for this trip',
        beneficiosLimiteAlcanzado: 'You already selected all available benefits for this trip.',
        sinPromocionesDisponibles: 'No promotions available at this time.',
        tarjetaCreadaExito: 'Benefit added. Valid for {dias} days.',
        finalizarSeleccion: 'Finish',
        seleccionar: 'Select',
        promocionYaElegida: 'You already selected this promotion for this trip.',
        viajeNoFinalizadoBeneficio: 'Only completed trips generate benefits.',
        canjearBeneficio: 'Redeem benefit',
        escanearQr: 'Scan merchant QR',
        ingresarCodigo: 'Enter manual code',
        codigoComercioPlaceholder: 'Merchant code',
        qrInvalido: 'The scanned QR is not valid.',
        qrScanError: 'Could not access the camera to scan the QR.',
        tarjetaVencida: 'This benefit has expired.',
        tarjetaYaUtilizada: 'This benefit has already been used.',
        estadoUtilizada: 'Used',
        estadoVencida: 'Expired',
        // Historial
        historialTitle: 'Trip history',
        totalViajes: 'Total trip',
        desde: 'From',
        hasta: 'To',
        noHayViajes: 'No trips',

        // Terms
        termsTitle: 'Terms and conditions',

        // Cancel Card
        cancelReason: 'Reason for cancellation',
        reasonShortMessage: 'You must write the reason why you canceled the trip.',
        reasonNoMessage: 'You must select the reason why you canceled the trip.',
        confirmarCancelacion: 'Are you sure you want to cancel the trip?',
        confirmarCancelacionConCargo: 'Are you sure you want to cancel the trip (YOU WILL BE CHARGE WITH THE MINIMUN AMMOUNT)?',

        // Trip
        viajeDoesntExist: 'The trip doesn\'t exist',
        viajeCaneladoPorChofer: 'The driver cancel the trip.',
        viajeCaneladoPorPasajero: 'The trip was canceled by the passenger.',
        viajeCaneladoPreviamentePorPasajero: 'The trip was canceled by the passenger.',
        viajeOfrecidoCancelado: 'The trip was canceled by the passenger.',
        viajeOfrecidoTomadoPorOtroChofer: 'The trip was taken by another driver.',
        reason: ' Reason: ',

        // Historial
        compartirApp: 'Share app...',
        compartirMensaje: 'Application to request trips.',

        // Atajos
        myUbication: 'Current location',
        language: 'Language',

        // Menu desplegable
        perfil: 'Profile',
        history: 'History',
        promotions: 'Promotions',
        compartir: 'Share',
        toc: 'Terms and conditions',
        registrameComoChofer: 'Sign up as driver',
        contacto: 'Contact us',

        metodosPago: 'Payment methods',
        explicacionMetodoPagoDefault: 'Select the method in which you want to pay for your trips by default.',
        configurar: 'Config',
        agregarMedioPago: 'Save payment method',
        noHayMetodos: 'No payment methods added yet.',
        successMethodDefault: 'Succesfully set the payment method as default',
        errorMethodDefault: 'There was an error setting the payment method as default',
        successMethodDelete: 'Succesfully deleted the payment method.',
        errorMethodDelete: 'Error deleting the payment method.',
        terminadaEn: 'ended in',
        expiraEl: 'expired in',

        telefonoCelular: 'Mobile phone',
        ingrese15: 'Enter the number without the 0 and 15.',
        cambiarContrasenia: 'Change password',
        numerosSeguridad: 'Security numbers',
        agregar: 'Add',
        quitar: 'Remove',
        numerosSeguridadAyuda: 'Enter up to 2 security numbers that will be notified by SMS in case you are in danger.',
        calificarViaje: 'Rate the trip',

        // Cuenta corriente
        currentAccount: 'Current Account',
        noMovements: 'No movements',
        totalMovements: 'Total movements',
        noVolverAMostrar: 'Do not show me this message again.',
        // App update
        appNewVersion: 'An update is available for the application. Please stay updated to get the best service.',

        // servicios
        transportePersonas: 'My Ryde',
        transporteMascotas: 'Pet Ryde',
        mensajeria: 'Messenger Ryde',
        precioSufijo: '',
        precioPrefijo: '$',
        precioActual: 'Current price',
        iconMoney: 'money',

        // mensajes
        audioEnviadoExito: 'Audio message succesfully sent',
        procesandoAudio: 'Proccesing the audio',
        escribaMensaje: 'Write a message',
        chatTitle: 'Chat',
        saludo: 'Hi, {name}. Where to?',

        // QR Payment
        qrPaymentReceived: 'QR Payment received'
    }
};



// WEBPACK FOOTER //
// ./src/assets/language/language.js